/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

export function getBreadScrumb(title: string, mainTitle: string = '고객센터') {
  return (
    <div className="breadscrumb">
      <>Home</>
      {' > '}
      <>{mainTitle}</>
      {' > '}
      <>{title}</>
    </div>
  );
}
